/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getSiteData } from "../../actions/manage-site-action-type";
import LayoutFirstDemo from "../layout-first-demo";
import Utils from "../../utils";
import LoaderComponent from "../common/loader/loader";
import DNQMain from "./dnq";
import LayoutFourth from "../layout-fourth";
import LayoutSeventh from "../layout-seventh";
import LayoutSixth from "../layout-sixth";
import LayoutFirst from "../beta-layout";

class DynamicDNQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      theme: "3",
      page: 1,
      isPageRefreshed: false,
    };
  }

  componentDidMount() {
    const { getSiteData, getSiteDataObject } = this.props;
    if (getSiteDataObject.length === 0) {
      this.setState({ isPageRefreshed: true });
      getSiteData(this.state.page);
    } else {
      Utils.renderFont(getSiteDataObject);
    }
  }

  render() {
    const { isLoading, getSiteDataObject } = this.props;
    const { isPageRefreshed } = this.state;

    return getSiteDataObject &&
      getSiteDataObject.content_manage_sites &&
      getSiteDataObject.content_manage_sites.length > 0 ? (
      getSiteDataObject.theme === "1" ? (
        <>
          <LayoutFirstDemo
            siteData={getSiteDataObject}
            pageType={"thankyou"}
            page={9}
            isPageRefreshed={isPageRefreshed}
          >
            <DNQMain siteData={getSiteDataObject} layoutType={getSiteDataObject.theme} />
          </LayoutFirstDemo>
        </>
      ) : getSiteDataObject.theme === "5" ? (
        <LayoutSixth
          siteData={getSiteDataObject}
          pageType={"thankyou"}
          isPageRefreshed={isPageRefreshed}
          page={9}
        >
          <DNQMain siteData={getSiteDataObject} layoutType={getSiteDataObject.theme} />
        </LayoutSixth>
      ) : getSiteDataObject.theme === "7" ? (
        <LayoutSeventh
          siteData={getSiteDataObject}
          pageType={"thankyou"}
          isPageRefreshed={isPageRefreshed}
          page={9}
        >
          <DNQMain siteData={getSiteDataObject} layoutType={getSiteDataObject.theme} />
        </LayoutSeventh>
      ) : getSiteDataObject.theme === "8" ? (
        <>
          <LayoutFirst
            siteData={getSiteDataObject}
            pageType={"thankyou"}
            page={9}
            isPageRefreshed={isPageRefreshed}
          >
           <DNQMain siteData={getSiteDataObject} layoutType={getSiteDataObject.theme} />
          </LayoutFirst>
        </>
      ) : (
        <LayoutFourth
          siteData={getSiteDataObject}
          pageType={"thankyou"}
          isPageRefreshed={isPageRefreshed}
          page={9}
        >
          <DNQMain siteData={getSiteDataObject} layoutType={getSiteDataObject.theme} />
        </LayoutFourth>
      )
    ) : isLoading ? (
      <LoaderComponent />
    ) : (
      <></>
    );
  }
}

const mapStateToProps = ({ ManageSite: { isLoading, getSiteDataObject } }) => ({
  isLoading,
  getSiteDataObject,
});

export default connect(mapStateToProps, { getSiteData })(DynamicDNQ);
